document.addEventListener("DOMContentLoaded", function () {

  const countdownElements = document.querySelectorAll('[data-countdown-date]');

  if (countdownElements.length === 0) return;

  // Initialize countdown for each element
  countdownElements.forEach(element => {
    const countdownDate = element.getAttribute('data-countdown-date');

    if (!countdownDate) return;

    initCountdown(element, countdownDate);
  });

  function initCountdown(element, targetDateString) {
    const targetDate = new Date(targetDateString);

    // Validate the date
    if (isNaN(targetDate.getTime())) {
      console.error('Invalid countdown date:', targetDateString);
      element.innerHTML = 'Invalid Date';
      return;
    }

    // Update countdown every second
    const interval = setInterval(() => {
      updateCountdown(element, targetDate, interval);
    }, 1000);

    // Initial update
    updateCountdown(element, targetDate, interval);
  }

  function updateCountdown(element, targetDate, interval) {
    const now = new Date().getTime();
    const distance = targetDate.getTime() - now;

    // If countdown has ended
    if (distance < 0) {
      clearInterval(interval);
      handleCountdownComplete(element);
      return;
    }

    // Calculate time units
    const timeUnits = calculateTimeUnits(distance);

    // Display the countdown
    displayCountdown(element, timeUnits);
  }

  function calculateTimeUnits(distance) {
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    return { days, hours, minutes, seconds };
  }

  function displayCountdown(element, timeUnits) {
    const { days, hours, minutes, seconds } = timeUnits;

    // Create countdown HTML structure
    const countdownHTML = `
      <div class="countdown-display">
        <div class="countdown-unit d-flex">
          <span class="countdown-number">${days.toString().padStart(2, '0')}</span>
        </div>
        <div class="countdown-separator">:</div>
        <div class="countdown-unit">
          <span class="countdown-number">${hours.toString().padStart(2, '0')}</span>
        </div>
        <div class="countdown-separator">:</div>
        <div class="countdown-unit">
          <span class="countdown-number">${minutes.toString().padStart(2, '0')}</span>
        </div>
        <div class="countdown-separator">:</div>
        <div class="countdown-unit">
          <span class="countdown-number">${seconds.toString().padStart(2, '0')}</span>
        </div>
      </div>
    `;

    element.innerHTML = countdownHTML;
  }

  function handleCountdownComplete(element) {
    element.innerHTML = `
      <div class="countdown-complete">
        <span class="countdown-complete-text">Event Started!</span>
      </div>
    `;

    // Add completed class for styling
    element.classList.add('countdown-completed');

    // Optional: Hide the entire countdown section
    const countdownSection = element.closest('.eventCountdown');
    if (countdownSection) {
      countdownSection.classList.add('countdown-expired');
    }
  }

  // Handle countdown close button functionality
  const closeButtons = document.querySelectorAll('.eventCountdown__closeButton');

  closeButtons.forEach(button => {
    button.addEventListener('click', function () {
      closeCountdown();
    });
  });

  function closeCountdown() {
    // Set cookie to remember countdown was closed (5 days expiry)
    const expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 5);
    document.cookie = `cntdwn=false; expires=${expiryDate.toUTCString()}; path=/`;

    // Hide countdown banner
    const countdownBanner = document.querySelector('.eventCountdown');
    if (countdownBanner) {
      countdownBanner.style.display = 'none';
    }

    // Remove countdown classes from headers
    const desktopHeader = document.querySelector('.desktopHeader');
    if (desktopHeader) {
      desktopHeader.classList.remove('desktopHeader--withCountdown');
    }

    const mobileHeader = document.querySelector('.mobileHeader');
    if (mobileHeader) {
      mobileHeader.classList.remove('mobileHeader--withCountdown');
    }

    // Reset site content margin
    const siteContent = document.querySelector('.site-content-contain');
    if (siteContent) {
      siteContent.style.marginTop = '0';
    }

    // Recalculate header heights with countdown height set to 0
    recalculateHeaderHeights();
  }

  function recalculateHeaderHeights() {
    const bodyEl = document.querySelector('body');
    const mobileMenu = document.querySelector('.mobileHeader');
    const desktopMenu = document.querySelector('.desktopHeader');
    const countdownHeight = 0; // Set to 0 since countdown is closed

    if (mobileMenu && mobileMenu.offsetHeight > 0) {
      let headerHeight = mobileMenu.offsetHeight + countdownHeight;
      let fixedHeaderHeight = (mobileMenu.offsetHeight - 43) + countdownHeight;
      bodyEl.style.setProperty('--header-height', headerHeight + "px");
      bodyEl.style.setProperty('--header-height-scrolled', fixedHeaderHeight + "px");
    } else if (desktopMenu) {
      let headerHeight = desktopMenu.offsetHeight + countdownHeight;
      let fixedHeaderHeight = (desktopMenu.offsetHeight - 43) + countdownHeight;
      bodyEl.style.setProperty('--header-height', headerHeight + "px");
      bodyEl.style.setProperty('--header-height-scrolled', fixedHeaderHeight + "px");
    }
  }

});
